import { inject } from "mobx-react";
import React from "react";
import { NetworkOperatorPrefixSchemaColumns } from "./schema";
import { CreateView, ShowView } from "lego-gui-lib/lib";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { useHistory } from "react-router";
import { observer } from "mobx-react-lite";

const injectDataSource = (comp: any) =>
  inject("networkOperatorPrefix", "i18n")(observer(comp));

export const CreateNetworkOperatorPrefix = injectDataSource(
  ({ networkOperatorPrefix, i18n, match, ...rest }: any) => {
    const title = i18n.t("common:create", {
      domain: "hns:networkOperatorPrefix:domain"
    });
    const baseUrl = match.url;
    const parentTitle = i18n.t("common:edit", {
      domain: "hns:networkOperator:domain"
    });
    const parentUrl = baseUrl.substring(0, baseUrl.lastIndexOf("/"));
    const id = {
      id: match.params.prefixId
    };
    const history = useHistory();

    return (
      <>
        <BreadcrumbsItem to={parentUrl}>{parentTitle}</BreadcrumbsItem>
        <BreadcrumbsItem to={baseUrl}>{title}</BreadcrumbsItem>
        <CreateView
          dataSource={networkOperatorPrefix.oneDataSource}
          {...rest}
          title={title}
          goBack={() => history.goBack()}
          fields={NetworkOperatorPrefixSchemaColumns}
          id={id.id ? id : undefined}
        />
      </>
    );
  }
);

export const ShowNetworkOperatorPrefix = injectDataSource(
  ({ networkOperatorPrefix, i18n, match }: any) => {
    const title = i18n.t("common:edit", {
      domain: "hns:networkOperatorPrefix:domain"
    });
    const baseUrl = match.url;
    const id = {
      id: match.params.prefixId
    };
    const parentTitle = i18n.t("common:edit", {
      domain: "hns:networkOperator:domain"
    });
    const parentUrl = baseUrl.substring(0, baseUrl.lastIndexOf("/"));
    const history = useHistory();

    return (
      <>
        <BreadcrumbsItem to={parentUrl}>{parentTitle}</BreadcrumbsItem>
        <BreadcrumbsItem to={baseUrl}>{title}</BreadcrumbsItem>
        <ShowView
          dataSource={networkOperatorPrefix.oneDataSource}
          title={title}
          goBack={() => history.goBack()}
          fields={NetworkOperatorPrefixSchemaColumns}
          id={id}
        />
      </>
    );
  }
);
